import React from 'react';

import type { IIcon } from '../types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 30, className, onClick }, ref) {
  return (
    <svg ref={ref} viewBox='0 0 512 512' onClick={onClick} width={size} height={size} className={className}>
      <path fill='#E2E5E7' d='M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z' />
      <path fill='#B0B7BD' d='M384,128h96L352,0v96C352,113.6,366.4,128,384,128z' />
      <polygon fill='#CAD1D8' points='480,224 384,128 480,128 ' />
      <path fill='#F15642' d='M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z' />
      <g>
        <path
          fill='#FFFFFF'
          d='M121.408,384.016c-4.096-2.32-6.656-6.912-4.096-12.288l36.72-71.76 c3.456-6.784,12.656-7.04,15.856,0l36.08,71.76c5.248,9.968-10.24,17.904-14.848,7.92l-5.632-11.248h-47.2l-5.488,11.264 ≈C130.752,384.016,126.016,384.912,121.408,384.016z M176.416,351.52l-14.464-31.6l-15.728,31.6H176.416z'
        />
        <path
          fill='#FFFFFF'
          d='M241.6,378.256l-33.776-70.736c-4.992-10.112,10.112-18.416,15.728-7.808l11.392,25.712 l14.704,33.76l14.448-33.76l11.392-25.712c5.12-9.712,19.952-3.584,15.616,7.04l-32.624,71.504 C255.536,386.32,246.448,388.24,241.6,378.256z'
        />
        <path fill='#FFFFFF' d='M306.88,303.152c0-10.48,16.896-10.88,16.896,0v73.04c0,10.624-16.896,10.88-16.896,0V303.152z' />
      </g>
      <path fill='#CAD1D8' d='M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z' />
    </svg>
  );
});

export default React.memo(Icon);
